import type { SpendPointsWaysToBoostTile } from './types';

const TILE_TITLE_PREVIEW_LENGTH = 18;

function createAlphabeticDraftSuffix(index: number): string {
  const alphabetLength = 26;
  let value = index;
  let label = '';

  do {
    label = String.fromCharCode(65 + (value % alphabetLength)) + label;
    value = Math.floor(value / alphabetLength) - 1;
  } while (value >= 0);

  return label;
}

export function createTileDraftLabel(index: number): string {
  return `Tile ${createAlphabeticDraftSuffix(index)}`;
}

function truncateTilePreview(value: string): string {
  return value.length > TILE_TITLE_PREVIEW_LENGTH ? `${value.slice(0, TILE_TITLE_PREVIEW_LENGTH)}...` : value;
}

export function formatTileTitle(tile: SpendPointsWaysToBoostTile): string {
  const previewSource = tile.title.trim();
  if (!previewSource) {
    return tile.draftLabel;
  }

  return `${tile.draftLabel} (${truncateTilePreview(previewSource)})`;
}

export function getNextTileDraftLabel(tiles: Array<SpendPointsWaysToBoostTile>): string {
  const usedLabels = new Set(tiles.map((tile) => tile.draftLabel));
  let index = 0;
  let nextLabel = createTileDraftLabel(index);

  while (usedLabels.has(nextLabel)) {
    index += 1;
    nextLabel = createTileDraftLabel(index);
  }

  return nextLabel;
}

export function moveTile(
  tiles: Array<SpendPointsWaysToBoostTile>,
  index: number,
  offset: -1 | 1,
): Array<SpendPointsWaysToBoostTile> {
  const targetIndex = index + offset;
  if (targetIndex < 0 || targetIndex >= tiles.length) {
    return tiles;
  }

  const nextTiles = [...tiles];
  [nextTiles[index], nextTiles[targetIndex]] = [nextTiles[targetIndex], nextTiles[index]];
  return nextTiles;
}
